module.exports = __webpack_public_path__ + "resources/img/img_deepfinder.c888bde0d5ae9d674e94a9fa861dcfb0.png";